export default __webpack_public_path__ + "static/media/scaphold.25e9bb14.svg";